import { useState, useEffect } from 'react'
import { useAuth } from '../context/AuthContext'
import Login from './Login'
import axios from 'axios'

import Navbar from './Navbar'

const UserReservation = () => {
    const [basicReservationData, setBasicReservationData] = useState([])
    const [bookingReservationData, setBookingReservationData] = useState([])
    const [slotReservationData, setSlotReservationData] = useState([])
    const [historyBasicReservations, setHistoryBasicReservations] = useState([])
    const [historyBookingReservations, setHistoryBookingReservations] = useState([])
    const [historySlotReservations, setHistorySlotReservations] = useState([])
    const [currentPage, setCurrentPage]= useState(1)
    const [itemPerPage, setItemPerPage] = useState(15)
    const { user, userToken } = useAuth()
    const [visible, setVisible] = useState({
            visibleActual: true,
            visibleHistory: false,
        })

    useEffect(() => {
        if (user && userToken) {
            const fetchBasicReservation = async () => {
                try {
                    const res = await axios.get(`${process.env.REACT_APP_API_URL}/users/basicReservation`, {
                        params: { userId: user._id },
                        headers: { Authorization: `Bearer ${userToken}` }
                    });

                    // Kontrola zda rezervace existují
                    if (res.data.reservations && res.data.reservations.length > 0) {
                        const today = new Date();
                        const history = res.data.reservations.filter(r => new Date(r.date) < today);
                        const upcoming = res.data.reservations.filter(r => new Date(r.date) >= today);
                        setHistoryBasicReservations(history);
                        setBasicReservationData(upcoming);
                    } else {
                        console.log("Žádné základní rezervace pro uživatele.");
                    }
                } catch (err) {
                    console.log("Chyba při načítání basic rezervace: ", err.response?.data?.message || err.message);
                }
            };

            const fetchBookingReservation = async () => {
                try {
                    const res = await axios.get(`${process.env.REACT_APP_API_URL}/users/bookingReservation`, {
                        params: { userId: user._id },
                        headers: { Authorization: `Bearer ${userToken}` }
                    });
                    console.log(res.data)
                    // Kontrola zda rezervace existují
                    if (res.data.reservations && res.data.reservations.length > 0) {
                        const today = new Date();
                        const reservation = res.data.reservations.map((reservation) => {
                            const history = reservation.reservations.filter(r => new Date(r.checkOutDate) < today);
                            const upcoming = reservation.reservations.filter(r => new Date(r.checkInDate) >= today);
                            return {
                                ...reservation, // Ponecháme původní data
                                history, 
                                upcoming
                            };
                        })
                        setBookingReservationData(reservation)
                        setHistoryBookingReservations(reservation)
                    } else {
                        console.log("Žádné booking rezervace pro uživatele.");
                    }
                } catch (err) {
                    console.log("Chyba při načítání booking rezervace: ", err.response?.data?.message || err.message);
                }
            };

            const fetchSlotReservation = async () => {
                try {
                    const res = await axios.get(`${process.env.REACT_APP_API_URL}/users/slotReservation`, {
                        params: { userId: user._id },
                        headers: { Authorization: `Bearer ${userToken}` }
                    });
                    // Kontrola zda rezervace existují
                    if (res.data.reservations && res.data.reservations.length > 0) {
                        const today = new Date();
                        const history = res.data.reservations.filter(r => new Date(r.date) < today);
                        const upcoming = res.data.reservations.filter(r => new Date(r.date) >= today);
                        setHistorySlotReservations(history);
                        setSlotReservationData(upcoming);
                    } else {
                        console.log("Žádné slot rezervace pro uživatele.");
                    }
                } catch (err) {
                    console.log("Chyba při načítání slot rezervace: ", err.response?.data?.message || err.message);
                }
            };

            // Spuštění každé funkce samostatně
            fetchBasicReservation();
            fetchBookingReservation();
            fetchSlotReservation();
        }
    }, [user, userToken]);

    const formattedDate = (date) => {
        return new Date(date).toLocaleDateString("cs-CZ");
    }

    //pocet itemu na stranku

    const indexOfLastItem = currentPage * itemPerPage;
    const indexOfFirstItem = indexOfLastItem - itemPerPage;
    
    
    const allReservations = [
        ...historyBasicReservations,
        ...historyBookingReservations,
        ...historySlotReservations
    ];
    
    // Seřazení podle správného datového klíče
    const sortedReservations = allReservations.sort((a, b) => {
        const getDate = (reservation) => {
            if (reservation.history && reservation.history.length > 0) {
                // Použijeme nejnovější checkInDate z historyBookingReservations
                return new Date(reservation.history[reservation.history.length - 1]?.checkInDate || 0);
            }
            // U ostatních použijeme date
            return new Date(reservation.date || 0);
        };
    
        const dateA = getDate(a);
        const dateB = getDate(b);
    
        return dateB - dateA; // Řazení od nejnovějšího po nejstarší
    });
    
    // Použití paginace
    const currentReservations = sortedReservations.slice(indexOfFirstItem, indexOfLastItem);
   
   
    const handleSelectNumber = (e) => {
        setItemPerPage(e.target.value)
    }

    //Strankovani
    const totalPages = Math.ceil(sortedReservations.length / itemPerPage)

    const handleChangePage = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage)
        }
        window.scrollTo(0, 0)
    } 
    //viditelnost 
    const handleChangeVisible = (e) => {
        const { name } = e.target; 

        setVisible((prevState) => ({
            visibleActual: name === 'actual' ? !prevState.visibleActual : false,
            visibleHistory: name === 'history' ? !prevState.visibleHistory : false,
        }));
    };

    if (!userToken) {
        return <Login />
    }

    return (
        <div className='min-height'>
            <Navbar />
            <div className="container-choice-buttons">
      {/* Tlačítka pro přepínání */}
      <div className="button-group-choice-buttons">
        <button
          name="actual"
          onClick={handleChangeVisible}
          className={`tab-choice-button ${visible.visibleActual ? "active" : ""}`}
        >
          Aktuální
        </button>

        <button
          name="history"
          onClick={handleChangeVisible}
          className={`tab-choice-button ${visible.visibleHistory ? "active" : ""}`}
        >
          Historie
        </button>
      </div>
    </div>
          {visible.visibleActual && <div>
            {basicReservationData && basicReservationData.map((data) => {
                return <div key={data._id} className="reservation-card">
                <div className="reservation-details">
                  <div className="reservation-item">
                    <h5 className="item-title">Místo</h5>
                    <p className="item-value">{data.business.name}</p>
                  </div>
              
                  <div className="reservation-item">
                    <h5 className="item-title">Datum</h5>
                    <p className="item-value">{formattedDate(data.date)}</p>
                  </div>
              
                  <div className="reservation-item">
                    <h5 className="item-title">Čas</h5>
                    <p className="item-value">{data.time}</p>
                  </div>
              
                  <div className="reservation-item">
                    <h5 className="item-title">Počet lidí</h5>
                    <p className="item-value">{data.numberOfPeople}</p>
                  </div>
              

                    <div className="item-value">
                      {data.status === "pending" && <div className="reservation-status pending">
                         <p>Čekání na potvrzení</p>
                    </div>}
                      {data.status === "confirmed" && <div className="reservation-status confirmed">
                        <p>Potvrzeno</p> 
                        </div>}
                      {data.status === "cancelled" && <div className="cancelled">
                        <p>Čekání na potvrzení</p>
                        </div>}
                    </div>
                  </div>
                </div>
            })}

{bookingReservationData && bookingReservationData.map((data, index) => 
    data.upcoming.map((item) => (
        <div key={`${data._id}-${item._id}`} className="reservation-card">
            <div className="reservation-details">
                <div className="reservation-item">
                    <h5 className="item-title">Místo</h5>
                    <p className="item-value">{data.business.name || "Neexistuje"}</p>
                </div>

                <div className="reservation-item">
                    <h5 className="item-title">Datum příjezdu</h5>
                    <p className="item-value">{formattedDate(item.checkInDate)}</p>
                </div>

                <div className="reservation-item">
                    <h5 className="item-title">Čas příjezdu od</h5>
                    <p className="item-value">{data.checkInTime}</p>
                </div>

                <div className="reservation-item">
                    <h5 className="item-title">Datum odjezdu</h5>
                    <p className="item-value">{formattedDate(item.checkOutDate)}</p>
                </div>

                <div className="reservation-item">
                    <h5 className="item-title">Čas odjezdu do</h5>
                    <p className="item-value">{data.checkOutTime}</p>
                </div>

                    <div className="item-value">
                        {item.status === "pending" && (
                            <div className="reservation-status pending">
                                <p>Čeká na potvrzení</p>
                            </div>
                        )}
                        {item.status === "confirmed" && (
                            <div className="reservation-status confirmed">
                                <p>Potvrzeno</p>
                            </div>
                        )}
                        {item.status === "cancelled" && (
                            <div className="reservation-status cancelled">
                                <p>Zrušeno</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

    ))
)}

{slotReservationData && slotReservationData.map((data) => {
    const startTime = data.timeSlots[0].startTime || "nezname";
    const endTime = data.timeSlots[data.timeSlots.length - 1].endTime || "nezname";
    const slotTime = `${startTime} - ${endTime}`;

    return (
        <div key={data._id} className="reservation-card">
            <div className="reservation-details">
                <div className="reservation-item">
                    <h5 className="item-title">Místo</h5>
                    <p className="item-value">{data.business.name || "Neexistuje"}</p>
                </div>

                <div className="reservation-item">
                    <h5 className="item-title">Datum</h5>
                    <p className="item-value">{formattedDate(data.date)}</p>
                </div>

                <div className="reservation-item">
                    <h5 className="item-title">Čas</h5>
                    <p className="item-value">{slotTime}</p>
                </div>

                <div className="reservation-item">
                    <h5 className="item-title">Služba</h5>
                    <p className="item-value">{data.service.name}</p>
                </div>

                <div className="reservation-item">
                    <h5 className="item-title">Cena</h5>
                    <p className="item-value">{data.service.price} Kč</p>
                </div>


                    <div className="item-value">
                        {data.status === "pending" && (
                            <div className="reservation-status pending">
                                <p>Čeká na potvrzení</p>
                            </div>
                        )}
                        {data.status === "confirmed" && (
                            <div className="reservation-status confirmed">
                                <p>Potvrzeno</p>
                            </div>
                        )}
                        {data.status === "cancelled" && (
                            <div className="reservation-status cancelled">
                                <p>Zrušeno</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

    );
})}
</div>  }
    {visible.visibleHistory && <div>

        <div className="select-container">
    
        <p>Počet rezervací na stránku</p>
        <select value={itemPerPage} onChange={handleSelectNumber}>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
            <option value="30">30</option>
        </select>

</div>
    {currentReservations && currentReservations.map((data) => {
    if (data.history) {
        // Pro Booking rezervace
        return (
            <div key={data._id} className="reservation-card">
                <div className="reservation-details">
                {data.history.map((item) => (
                    <div key={item._id} >
                        <div className="reservation-item">
                            <h5 className="item-title">Místo</h5>
                            <p className="item-value">{data.business.name || "Neexistuje"}</p>
                        </div>

                        <div className="reservation-item">
                            <h5 className="item-title">Datum příjezdu</h5>
                            <p className="item-value">{formattedDate(item.checkInDate)}</p>
                        </div>

                        <div className="reservation-item">
                            <h5 className="item-title">Čas příjezdu od</h5>
                            <p className="item-value">{data.checkInTime}</p>
                        </div>

                        <div className="reservation-item">
                            <h5 className="item-title">Datum odjezdu</h5>
                            <p className="item-value">{formattedDate(item.checkOutDate)}</p>
                        </div>

                        <div className="reservation-item">
                            <h5 className="item-title">Čas odjezdu do</h5>
                            <p className="item-value">{data.checkOutTime}</p>
                        </div>


                            <div className="item-value">
                                {item.status === "pending" && (
                                    <div className="reservation-status pending">
                                        <p>Nespecifikováno</p>
                                    </div>
                                )}
                                {item.status === "confirmed" && (
                                    <div className="reservation-status confirmed">
                                        <p>Proběhlo</p>
                                    </div>
                                )}
                                {item.status === "cancelled" && (
                                    <div className="reservation-status cancelled">
                                        <p>Neproběhlo</p>
                                    </div>
                                )}
                            </div>
                    </div>
                ))}
                </div>
            </div>
        );
    } else if (data.timeSlots) {
        // Pro Slot rezervace
        const startTime = data.timeSlots[0].startTime || "nezname";
        const endTime = data.timeSlots[data.timeSlots.length - 1].endTime || "nezname";
        const slotTime = `${startTime} - ${endTime}`;

        return (
            <div key={data._id} className="reservation-card">
                <div className="reservation-details">
                    <div className="reservation-item">
                        <h5 className="item-title">Místo</h5>
                        <p className="item-value">{data.business.name || "Neexistuje"}</p>
                    </div>

                    <div className="reservation-item">
                        <h5 className="item-title">Datum</h5>
                        <p className="item-value">{formattedDate(data.date)}</p>
                    </div>

                    <div className="reservation-item">
                        <h5 className="item-title">Čas</h5>
                        <p className="item-value">{slotTime}</p>
                    </div>

                    <div className="reservation-item">
                        <h5 className="item-title">Služba</h5>
                        <p className="item-value">{data.service.name}</p>
                    </div>

                    <div className="reservation-item">
                        <h5 className="item-title">Cena</h5>
                        <p className="item-value">{data.service.price}</p>
                    </div>

                        <div className="item-value">
                            {data.status === "pending" && (
                                <div className="reservation-status pending">
                                    <p>Nespecifikováno</p>
                                </div>
                            )}
                            {data.status === "confirmed" && (
                                <div className="reservation-status confirmed">
                                    <p>Proběhlo</p>
                                </div>
                            )}
                            {data.status === "cancelled" && (
                                <div className="reservation-status cancelled">
                                    <p>Neproběhlo</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

        );
    } else {
        // Pro Basic rezervace
        return (
            <div key={data._id} className="reservation-card">
                <div className="reservation-details">
                    <div className="reservation-item">
                        <h5 className="item-title">Místo</h5>
                        <p className="item-value">{data.business.name || "Neexistuje"}</p>
                    </div>

                    <div className="reservation-item">
                        <h5 className="item-title">Datum</h5>
                        <p className="item-value">{formattedDate(data.date)}</p>
                    </div>

                    <div className="reservation-item">
                        <h5 className="item-title">Čas</h5>
                        <p className="item-value">{data.time}</p>
                    </div>

                    <div className="reservation-item">
                        <h5 className="item-title">Počet lidí</h5>
                        <p className="item-value">{data.numberOfPeople}</p>
                    </div>


                        <div className="item-value">
                            {data.status === "pending" && (
                                <div className="reservation-status pending">
                                    <p>Nespecifikováno</p>
                                </div>
                            )}
                            {data.status === "confirmed" && (
                                <div className="reservation-status confirmed">
                                    <p>Proběhlo</p>
                                </div>
                            )}
                            {data.status === "cancelled" && (
                                <div className="reservation-status cancelled">
                                    <p>Neproběhlo</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
        );
    }
})}

<div className="pagination-container">
    <button onClick={() => handleChangePage(currentPage - 1)} disabled={currentPage === 1}>
        Předchozí
    </button>
    <span> {currentPage} / {totalPages} </span>
    <button onClick={() => handleChangePage(currentPage + 1)} disabled={currentPage === totalPages}>
        Další
    </button>
</div>

        </div>}
    </div>
    )
}

export default UserReservation